import React, { useState, useEffect } from 'react'
import { backendUrl } from '../../Services/backend-url'
import { getAmount } from '../../Services/util-functions'

// Components
import AccountOverview from './AccountOverview'
import BillsList from '../Bills/BillsList'
import ExpensesList from '../Expenses/ExpensesList'
import Header from '../Home/Header'
import Loading from './Loading'

// Styles
import '../Bills/bills.css'
import '../Expenses/expenses.css'

const UserPage = props => {
  const [username] = useState(props.location.state.username)
  const [payday, setPayday] = useState({})
  const [bills, setBills] = useState([])
  const [expenses, setExpenses] = useState([])
  const [savings, setSavings] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [location, setLocation] = useState('')
  const [title, setTitle] = useState('Account Overview')
  const user = { username, payday, bills, expenses, savings }

  const setupUser = accountInfo => {
    setPayday(accountInfo.payday)
    setBills(accountInfo.bills)
    setExpenses(accountInfo.expenses)
    setSavings(accountInfo.savings)
    setLocation('overview')
  }

  useEffect(() => {
    async function fetchUserData () {
      const res = await window.fetch(backendUrl + `account-info/${username}`)
      const accountInfo = await res.json()
      setupUser(accountInfo)
      setTimeout(() => setIsLoading(false, 500))
    }
    if (!payday.amount) {
      fetchUserData()
    }
    window.scrollTo(0, 0)
  }, [isLoading, username, payday, location])

  const handleBack = () => {
    setLocation('overview')
    setTitle('Account Overview')
  }

  const handleUpdatedPayday = payday => {
    setIsLoading(true)
    setPayday(payday)
    setIsLoading(false)
  }

  const handleUpdatedSavings = savings => {
    setIsLoading(true)
    setSavings(savings)
    setIsLoading(false)
  }

  const handleViewBills = () => {
    setLocation('billsList')
    setTitle('Bills')
  }

  const handleAddedBill = bill => {
    setBills([...bills, bill])
  }

  const handleUpdatedBill = newBills => {
    setIsLoading(true)
    setBills(newBills)
    setIsLoading(false)
  }

  const handleDeletedBill = newBills => {
    setIsLoading(true)
    setBills(newBills)
    setIsLoading(false)
  }

  const handleViewExpenses = () => {
    setLocation('expensesList')
    setTitle('Expenses')
  }

  const handleAddedExpense = expense => {
    setExpenses([...expenses, expense])
  }

  const handleUpdatedExpense = newExpenses => {
    setIsLoading(true)
    setExpenses(newExpenses)
    setIsLoading(false)
  }

  const handleDeletedExpense = newExpenses => {
    setIsLoading(true)
    setExpenses(newExpenses)
    setIsLoading(false)
  }

  const addOutFlow = (bills, expenses) => {
    let count = 0
    bills.forEach(bill => {
      count += bill.amount
    })
    expenses.forEach(expense => {
      count += expense.amount
    })
    return count + savings.amount
  }

  return (
    <div className='userpage'>
      <Header />
      <div className='account-background bg-light-blue-gradient' />
      <div className='account-overview text-center'>
        <h1 className='roboto white bg-middle-green-gradient account-page-title'>
          {title}
          {
            payday.amount
              ? (
                <p className='font75'>Remaining: {payday.amount ? getAmount(payday.amount - addOutFlow(bills, expenses)) : 'mathing...'}</p>
              ) : <p className='font75'>0</p>
          }
        </h1>
        {
          isLoading
            ? <Loading />
            : location === 'overview'
              ? (
                <AccountOverview
                  user={user}
                  handleUpdatedPayday={handleUpdatedPayday}
                  handleUpdatedSavings={handleUpdatedSavings}
                  handleViewBills={handleViewBills}
                  handleViewExpenses={handleViewExpenses}
                />
              )
              : location === 'billsList'
                ? (
                  <BillsList
                    user={user}
                    handleBack={handleBack}
                    handleAddedBill={handleAddedBill}
                    handleUpdatedBill={handleUpdatedBill}
                    handleDeletedBill={handleDeletedBill}
                  />
                )
                : location === 'expensesList'
                  ? (
                    <ExpensesList
                      user={user}
                      handleBack={handleBack}
                      handleAddedExpense={handleAddedExpense}
                      handleUpdatedExpense={handleUpdatedExpense}
                      handleDeletedExpense={handleDeletedExpense}
                    />
                  )
                  : <h1>could not load :(</h1>
        }
      </div>
    </div>
  )
}

export default UserPage
